<template>
  <div class="news">
    <img :src="bannerImg" class="bannerImg" />
    <an-child>
      <div slot="c_left" class="left_nav">
      	<h3 class="title-color"><a>{{$store.state.langData.home.news}}</a></h3>
        <ul>
          <li v-for="(item,index) in cleft" :key="index">
            <router-link :to="'/news'+'?type='+item.type" exact>{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <div slot="c_right">
      <div class="bread d-flex">
          <h3 class="flex-auto">
            <!-- <a class="text-blue">{{title}}</a> -->
            <a class="text-blue" v-show="!$route.query.keyword">{{title}}</a>
            <a class="text-blue" v-show="$route.query.keyword">搜索结果</a>
          </h3>
          <div class="text-gray_dark d-flex">
            <span><img src="@/assets/images/p.png" class="pic"></span>
            {{$store.state.langData.nowAddress}}：           
            <router-link :to="'/news?type='+type">{{$store.state.langData.home.news}}</router-link>>
            <a>{{title}}</a>
          </div>
      </div>
          <div class="news_events">
		        <!--<h2><span>安邦</span>{{title}}</h2>-->
		        <div class="news_list">
		            <router-link :to="'/detail?handler=getNewsDetail&filed=content&id='+i.id" v-for="(i,n) in newsList" :key="n">
		                <div class="d-flex news_list_item">
		                    <div class="flex-auto">
		                        <!-- <img :src="i.imageUrl" alt=""> -->
                            
                            <h5><i></i>{{i.title}}</h5>
		                    </div>
		                    <div class="sec_box font16">
                            <p class="e_time font14">{{i.reportTime}}</p>
		                        <!-- <p class="intro">{{i.subhead}}</p> -->
		                    </div>
		                </div>
		            </router-link>
		        </div>
            <div class="text-center" v-show="newsList.length==0">{{$store.state.langData.noData}}</div>
		        <div class="pagenation" v-show="totalPages>0">
		            <an-pagenation
                    :startPage="startPage"
                    :endPage="endPage"
                    :currentPage="currentPage"
                    @numberClick="handlePageClick"
                    @lastClick="handleLastClick"
                    @nextClick="handleNextClick"
		                align="center">
		            </an-pagenation>    
		        </div>
		    </div>
      </div>
    </an-child>
  </div>
</template>

<script>
import { getBanner } from "@/api";
import { getNews,getNewsMediaList } from "@/api/hjy";
export default {
  name: "News",
  data(){
        return {
            cleft:[],
            bannerImg:'',//banner
            newsList:[],
            bannerShow:false,
            totalPages:0,//总页数
            currentPage:1,//当前页数
            startPage:1,//开始页
            endPage:1,//结束页
        }
   },
   methods: {
      //获取分类
      getNewsMediaList(){
        getNewsMediaList()
        .then(res => this.cleft.push(...res.data))
        .catch(e => console.log(e))
      },
      // 获取banner
      getBannerImg() {
        getBanner({
          params: 3,
          ad_type: 3
        })
        .then(res => {
          this.bannerImg = res.list[0].imageUrl;
          this.bannerShow = true;
        });			
      },
      getNewsList() {
        getNews({
            type: this.$route.query.type,
            page: this.currentPage,
            size: 10,
          })
          .then(res => {
            this.newsList = res.data.data;
            this.totalPages=res.data.totalPages;
            this.startPage=this.currentPage<=2?1:this.currentPage-2;
            if(this.startPage+4>this.totalPages){
              this.endPage=this.totalPages;
              this.startPage=this.endPage-4<1?1:this.endPage-4;
            }else{
                this.endPage=this.startPage+4;
            } 
          })
          .catch(e=>console.log(e));;
      },
      handlePageClick(num){
        this.currentPage=num;
        this.getProductList();
      },
      handleLastClick(){
        this.currentPage === 1 ? null : this.currentPage--;
        this.getProductList();
      },
      handleNextClick(){
        this.currentPage === this.totalPages ? null : this.currentPage++;
        this.getProductList();
      }
    },
		computed: {
			title() {
				let type = this.$route.query.type;
				let t = '';
				this.cleft.map(n => {
					if(n.type ==  type) {
						t = n.name;
						return;
					}
				});
				this.getNewsList();
				return t;
      },
      type(){
        return this.cleft.length>0?this.cleft[0].type:''
      }
    },
    mounted(){
      this.getBannerImg();
      this.getNewsMediaList();
    }
};
</script>
<style lang="stylus">
  .bannerImg
    width 1200px
    height auto 
    margin 15px auto !important
    display block
  .news
    padding-bottom 88px
	.news_events
    .sec_box
        padding-left 20px
    h2
        font-weight normal
        margin-bottom 12px
        color #ED822A
        font-size 36px
        span
            color #1278C6
    .news_list
        .news_list_item
            padding 0 !important
            border-bottom 0 !important
        img 
            width 240px
            height 166px 
        i
            display inline-block
            width 5px
            height 5px
            background #333
            border-radius 50%
            margin-right 5px
            vertical-align middle
        .e_time
            color #6b6b6b !important
            margin 6px 0
        h5
            color #333 !important
            font-size 14px !important
            margin 6px 0 !important
            color #333
            font-size 14px
            margin 6px 0
            font-weight normal
        h5:hover
            color #e36c09
        .intro
            color #222222
            line-height 24px   
    .pagenation
        margin 58px 0   
</style>